const pokeNameFix = {
  'nidoran-f': 'nidoran',
  'nidoran-m': 'nidoran',
  'deoxys-normal': 'deoxys',
  'wormadam-plant': 'wormadam',
  'giratina-altered': 'giratina',
  'shaymin-land': 'shaymin',
  'basculin-red-striped': 'basculin',
  'darmanitan-standard': 'darmanitan',
  'tornadus-incarnate': 'tornadus',
  'thundurus-incarnate': 'thundurus',
  'landorus-incarnate': 'landorus',
  'keldeo-ordinary': 'keldeo',
  'meloetta-aria': 'meloetta',
  'meowstic-male': 'meowstic',
  'aegislash-shield': 'aegislash',
  'pumpkaboo-average': 'pumpkaboo',
  'gourgeist-average': 'gourgeist',
  'zygarde-50': 'zygarde',
  'oricorio-baile': 'oricorio',
  'lycanroc-midday': 'lycanroc',
  'wishiwashi-solo': 'wishiwashi',
  'minior-red-meteor': 'minior',
  'mimikyu-disguised': 'mimikyu',
  'toxtricity-amped': 'toxtricity',
  'eiscue-ice': 'eiscue',
  'indeedee-male': 'indeedee',
  'morpeko-full-belly': 'morpeko',
  'urshifu-single-strike': 'urshifu'
}

export default pokeNameFix;